import { IMessageContext } from "@saleor/components/messages";
import { MutationFunction } from "react-apollo";

import { Order } from "./components/BatchAssignmentListHead";
import {
  orderRiderDispatchSearchAndValidation,
  orderRiderDispatchSearchAndValidationVariables
} from "./types/orderRiderDispatchSearchAndValidation";

export const validateOrder = async (
  order_number: string,
  riderId: string,
  order_state: Order[],
  validateOrderMutation: MutationFunction<
    orderRiderDispatchSearchAndValidation,
    orderRiderDispatchSearchAndValidationVariables
  >,
  notify: IMessageContext
) => {
  if (order_state.some(id => id.orderCode === order_number)) {
    notify({
      status: "error",
      text: "Order number is already added on the list"
    });
    return false;
  }

  const result = await validateOrderMutation({
    variables: {
      orderCodes: [order_number],
      riderId
    }
  });

  const {
    data: {
      orderRiderDispatchSearchAndValidation: {
        hasErrors,
        ordersWithError,
        orders
      }
    }
  } = result;

  if (!hasErrors) {
    notify({
      status: "success",
      text: `Order ${order_number} has been added`
    });
    const order = { ...orders[0], isValid: true };
    return order;
  } else {
    const error = Object.values(JSON.parse(ordersWithError))[0];
    switch (error) {
      case "Invalid order code":
        notify({
          status: "error",
          text: "Order number is not available"
        });
        break;
      case "Invalid order status.":
        notify({
          status: "error",
          text: "Order number is not ready to ship"
        });
        break;
      default:
        notify({
          status: "error",
          text: error
        });
        break;
    }
    return false;
  }
};

export const validateOrders = async (
  orders,
  riderId,
  validateOrderMutation: MutationFunction<
    orderRiderDispatchSearchAndValidation,
    orderRiderDispatchSearchAndValidationVariables
  >
) => {
  if (orders.length !== 0) {
    const createNewOrderArray = orders.map(e => e.orderCode);
    const result = await validateOrderMutation({
      variables: {
        orderCodes: createNewOrderArray,
        riderId
      }
    });
    const {
      data: {
        orderRiderDispatchSearchAndValidation: {
          ordersWithError,
          orders: newOrders
        }
      }
    } = result;

    const orderErrors = Object.keys(JSON.parse(ordersWithError));

    return newOrders.map(e => {
      if (orderErrors.some(elementError => elementError === e.orderCode)) {
        return { ...e, isValid: false };
      } else {
        return { ...e, isValid: true };
      }
    });
  } else {
    return [];
  }
};
